// src/customer-form/DescriptionField.jsx
const descriptionLabels = { en: 'Description', fr: 'Description', ar: 'الوصف' };

function getLanguage(country) {
  if (country === 'Morocco') return 'ar';
  if (country === 'Senegal' || country === "Cote D'ivoire") return 'fr';
  return 'en';
}

export default function DescriptionField({ formData, handleChange, handleBlur, errors = {}, touched = {} }) {
  const lang = getLanguage(formData.country);
  return (
    <div className={`field ${touched.description && errors.description ? 'has-error' : ''}`}>
      <label className="label">{descriptionLabels[lang]} <span className="required">*</span></label>
      {touched.description && errors.description && <div className="error-message">{errors.description}</div>}
      <textarea className="textarea" name="description" rows={6} value={formData.description} onChange={handleChange} onBlur={handleBlur} placeholder="Describe your issue in detail..." required />
    </div>
  );
}
